import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
   StatusBar,
   StyleSheet,
   Text,
   View,
   Animated,
   Dimensions,
   TouchableOpacity,
   ActivityIndicator,
   Platform,
} from 'react-native';

import {
   appBackgroundWhiteBG,
   base100,
   norcatAppColor,
   GET_BROWSE,
   white,
   BROUS,
   DASHBOARD,
   MYTRAINING,
   PROFILE,
   FONT_FAMILY_REGULAR,
   isWeb,
   ActivityLoaderColor,
   isWindows,
} from '../../utils/utils';
import {ApplicationHeader} from '../../utils/application_header';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {BrowseList} from './BrowseList';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import BrowsesHeader from './BrowsesHeader';
import {
   apiPostRequest,
   showTokenExpireAlertWeb,
} from '../../service/network_access';
import Landscap_Application_Header from '../../utils/Landscap_Application_Header';
import {selectAuthData} from '../../redux/slices/AuthSlice';
import BrowsedHeaderLandsacape from './BrowsesHeaderLandscape';
import logger from '../../utils/logger';
import {
   getPageData,
   getPageReload,
   setPageData,
} from '../../redux/slices/ReloadBrowsPageDataSlice';
const BrowsesCoursesScreen = () => {
   const navigation = useNavigation();
   const [showView, setShowView] = useState(false);
   const [browseList, setBrowseList] = useState([]);
   const [data, setBrowserCount] = useState('');
   const [animatedValue] = useState(new Animated.Value(-2000));
   const {width, height} = Dimensions.get('window');
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [isApiLoading, setIsApiLoading] = useState(false);
   const [searchQuery, setSearchQuery] = useState('');
   const authData = useSelector(selectAuthData);
   const [tempBrowseList, settempBrowseList] = useState([]);
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const dispatch = useDispatch();
   const isPageReload = useSelector(getPageReload);
   const storePageData = useSelector(getPageData);
   const isScreenFocused = useIsFocused();
   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         if (isPageReload && Platform.OS == 'windows') {
            getBrowseDataFromAPI();
         } else if (Platform.OS == 'windows') {
            const enrolledCourses = storePageData;
            const parsedData = JSON.parse(JSON.stringify(enrolledCourses));
            const browseCount = parsedData.length;
            setBrowseList(enrolledCourses);
            setBrowserCount(browseCount);
            settempBrowseList(enrolledCourses);
            dispatch(setPageData(enrolledCourses));
         } else {
            getBrowseDataFromAPI();
         }
      }
   }, []);

   const handlePress = () => {
      setShowView(!showView);
      Animated.timing(animatedValue, {
         toValue: showView ? -1000 : 0,
         duration: 300,
         useNativeDriver: false,
      }).start();
   };

   const hanleDrawerNavigation = id => {
      const rowSelected = parseInt(id, 10);
      switch (rowSelected) {
         case 1:
            navigation.navigate('DashboardScreen');
            break;
         case 2:
            // Navigate to My Tranings
            break;
         case 3:
            // Navigate to Browse Courses
            navigation.navigate('BrowsesCoursesScreen');
            break;
         case 4:
            // Navigate to Logout
            navigation.navigate('LogoutScreen');
            break;
         default:
      }
   };

   function getBrowseDataFromAPI() {
      (async () => {
         const reqParms = {
            theData: JSON.stringify({
               CompanyKey: authData.CompanyKey,
            }),
         };
         setIsApiLoading(true);
         apiPostRequest({url: GET_BROWSE, parms: reqParms})
            .then(res => {
               setIsApiLoading(false);
               if (
                  res !== null &&
                  res !== undefined &&
                  typeof res !== 'string'
               ) {
                  setIsApiLoading(false);
                  const enrolledCourses = res.CourseRecordsList;
                  const parsedData = JSON.parse(
                     JSON.stringify(enrolledCourses),
                  );
                  const browseCount = parsedData.length;
                  setBrowseList(enrolledCourses);
                  setBrowserCount(browseCount);
                  settempBrowseList(enrolledCourses);
                  if (Platform.OS == 'windows') {
                     dispatch(setPageData(enrolledCourses));
                  }
               } else {
                  if (isWeb) {
                     showTokenExpireAlertWeb(res);
                  } else {
                     alert(res);
                  }
               }
            })
            .catch(err => logger({err}));
      })();
   }

   function searchFilterList(text) {
      if (text === '') {
         setBrowseList(tempBrowseList);
      }
      if (tempBrowseList && Array.isArray(tempBrowseList)) {
         const list = tempBrowseList.filter(function (item) {
            // Applying filter for the inserted text in search bar
            const itemData = item.Name
               ? item.Name.toUpperCase()
               : ''.toUpperCase();
            const textData = text.toUpperCase();
            return itemData.indexOf(textData) > -1;
         });
         setBrowseList(list);
      }
   }

   const handlePressWhenDrawerVisible = () => {
      if (showView) {
         handlePress();
      }
   };

   return (
      <View
         style={[
            styles.container,
            {
               ...Platform.select({
                  web: {
                     flex: null,
                     //height: '100vh',
                     height: !isLandscapemode
                        ? isLandscapeSmallWebView
                           ? '100%'
                           : '100vh'
                        : '100vh',
                     minHeight: isLandscapeSmallWebView ? '100vh' : null,
                     overflowY: isLandscapemode ? 'hidden' : null,
                  },
               }),
            },
         ]}>
         {/*Animation view and Drawer menu only for portrait mobile app*/}
         {isApiLoading && (
            <ActivityIndicator
               size="large"
               color={ActivityLoaderColor}
               style={{
                  position: 'absolute',
                  top: 120,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  zIndex: 1,
               }}
            />
         )}
         {!isLandscapemode ? (
            <Animated.View
               style={[
                  {
                     backgroundColor: 'transparent',
                     width: '75%',
                     flex: 1,
                     height: '100%',
                     position: 'absolute',
                     left: animatedValue,
                  },
                  showView ? {zIndex: 1} : {zIndex: 1},
               ]}
            />
         ) : (
            <Landscap_Application_Header
               authData={authData}
               selectedTab={BROUS}
               isProfileScreen={false}
               onProfileClick={() => {
                  navigation.navigate('ProfileScreen');
               }}
               onTopMenuClick={value => {
                  if (value === DASHBOARD) {
                     navigation.navigate('DashboardScreen');
                  } else if (value === MYTRAINING) {
                     navigation.navigate('MyTraningScreen');
                  } else if (value === PROFILE) {
                     navigation.navigate('ProfileScreen');
                  } else if (value === BROUS) {
                     navigation.navigate('BrowsesCoursesScreen');
                  }
               }}
               dataSource={['View Profile', 'Edit Profile', 'Logout']}
            />
         )}

         {/* Check of HeaderView for Mobile(ApplicationHeader) and others platform(DashboardHeaderLandsacap)*/}
         {!isLandscapemode ? (
            <ApplicationHeader
               OnBackPress={() => {
                  navigation.goBack();
               }}
            />
         ) : (
            <View style={{flexDirection: 'row', flex: 1}}>
               <View style={{flex: 1}}>
                  <BrowsedHeaderLandsacape
                     authData={authData}
                     enrolledCount={data}
                     title="Browse Courses"
                     subtitle=""
                     icon={require('../../assets/filter-search.png')}
                     showSearchView={true}
                     showCourses={true}
                     onClearText={() => {
                        setBrowseList(tempBrowseList);
                     }}
                     onSearch={text => {
                        searchFilterList(text);
                     }}
                  />
                  <View style={{flex: 1}}>
                     {browseList?.length === 0 && !isApiLoading ? (
                        <View style={{flex: 1, justifyContent: 'center'}}>
                           <Text
                              style={{
                                 color: 'black',
                                 // height: '100%',
                                 alignSelf: 'center',
                                 justifyContent: 'center',
                                 alignItems: 'center',
                                 textAlignVertical: 'center',
                                 alignContent: 'center',
                              }}>
                              NO COURSES AVAILABLE
                           </Text>
                        </View>
                     ) : (
                        <BrowseList browseListData={browseList} />
                     )}
                  </View>
               </View>
            </View>
         )}
         <StatusBar backgroundColor={norcatAppColor} />

         {/*DashboardHeader view portrait mobile app*/}
         {!isLandscapemode ? (
            <View style={{flex: 1}}>
               <BrowsesHeader
                  enrolledCount={data}
                  onSearch={text => {
                     searchFilterList(text);
                  }}
                  onClearText={() => {
                     setBrowseList(tempBrowseList);
                  }}
               />
               <View style={{flex: 1}}>
                  {browseList?.length === 0 && !isApiLoading ? (
                     <View style={{flex: 1, justifyContent: 'center'}}>
                        <Text
                           style={{
                              color: 'black',
                              // height: '100%',
                              alignSelf: 'center',
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlignVertical: 'center',
                              alignContent: 'center',
                           }}>
                           NO COURSES AVAILABLE
                        </Text>
                     </View>
                  ) : (
                     <BrowseList browseListData={browseList} />
                  )}
               </View>
            </View>
         ) : null}
         {showView && !isLandscapemode ? (
            <TouchableOpacity
               style={[styles.transParentView, {height: height}]}
               onPress={() => {
                  handlePress();
               }}>
               <View>
                  {/*This view is being used for showing transparent view on opening of menu drawyer */}
               </View>
            </TouchableOpacity>
         ) : null}
      </View>
   );
};

const styles = StyleSheet.create({
   container: {flex: 1, backgroundColor: appBackgroundWhiteBG},
   inputStyle: {
      width: '100%',
      height: 40,
      backgroundColor: white,
      marginTop: 8,
      borderWidth: 1,
      paddingHorizontal: 14,
      borderColor: '#AFBACA',
      borderRadius: 6,
      fontSize: 14,
      textAlignVertical: 'center',
      alignItems: 'center',
      color: base100,
      fontWeight: '700',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   titleStyle: {
      fontSize: 14,
      marginTop: 16,
      color: '#3D4A5C',
      fontWeight: '600',
      fontFamily: FONT_FAMILY_REGULAR,
   },
   profileStyle: {
      paddingHorizontal: 16,
      paddingVertical: 8,
      flexDirection: 'column',
   },
   transParentView: {
      backgroundColor: 'rgba(0,0,0,0.2)',
      width: '25%',
      flexDirection: 'row-reverse',
      alignSelf: 'flex-end',
      position: 'absolute',
      zIndex: 999,
   },
});
export default BrowsesCoursesScreen;
